import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';
import Title from 'components/atoms/texts/Title';

const BorderTitleStart = ({ title }) => {
    return (
        <Container>
            <Title title={title} />
        </Container>
    );
};

BorderTitleStart.propTypes = {
    title: PropTypes.string.isRequired
};

export default BorderTitleStart;
